/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { HTTP_METHOD } from "@nf/constants";
import { skymillHttpService } from "../../../../services";
import { ILocalesResponseModel } from "../models";


export class LocalizationService {
  get url(): string {
    return "/v3";
  }

  public locales = (): Promise<ILocalesResponseModel> =>
    skymillHttpService.request<ILocalesResponseModel>(
      {
        method: HTTP_METHOD.GET,
        url: `${this.url}/locales`,
      },
    );
}
